/**
 * True when a connect attempt failed because the identity already belongs to
 * another account. Two sources produce this: the backend's
 * `AUTH_PROVIDER_ALREADY_LINKED` cross-user check, and Turnkey's own duplicate
 * rejection ("Account already exists with this OIDC token or claims" /
 * "already been imported"), which fires before the backend is ever called.
 */
export function isLinkedElsewhereError(message: string): boolean {
  return /ALREADY_LINKED|already linked|already exists|already been imported/i.test(message);
}
